import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { snakes } from '@utils/lodash';
import { Numeric, WithParams } from '@utils/typescript';
import { paginate, Pagination, PaginationParams } from '@models/Pagination';
import { PolicyCommissionInvoiceList, PolicyCommissionInvoice, CashFlows } from '@models/PolicyCommissionInvoice';

export type GetAllPolicyCommissionInvoiceParams = PaginationParams & WithParams<{
  insurance_policy_id?: number;
}>;

export type GetPolicyCommissionInvoiceParams = WithParams<{
  id: number;
}>;

export type CreatePolicyCommissionInvoiceParams = WithParams<{
  insurance_policy_id: number;
  total_premium: Numeric;
  cash_flow: CashFlows | '';
}>;

export class PolicyCommissionInvoiceApi {
  static getAll = async (params: GetAllPolicyCommissionInvoiceParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/policy_commission_invoices`, { params: snakes(params) })
      .then((response) => paginate(response) as [PolicyCommissionInvoiceList[], Pagination]);
  };

  static create = async (params: CreatePolicyCommissionInvoiceParams) => {
    return await authAxios
      .post(`${API_V1_BASE}/user/policy_commission_invoices`, snakes(params))
      .then((response) => humps(response.data) as PolicyCommissionInvoice);
  };

  static get = async ({ id }: GetPolicyCommissionInvoiceParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/policy_commission_invoices/${id}`)
      .then((response) => humps(response.data) as PolicyCommissionInvoice);
  };
}
